import { apiClient } from "../../../base/ApiClient";

export const getEmployeeCapacityReport = async (selectedDate, locationId, areaId) => {
  const response = await apiClient.get(`/candidate/capacity-report/`, {
    params: {
      date: selectedDate,
      location_id: locationId,
      area_id: areaId,
    },
  });
  return response.data;
};